import React, { useState, useEffect, useCallback } from 'react';
import { DistrictTypeIdEnum } from '../../../../../../../../../../Enums';
import { AutocompleteComponent } from '../../../../../../../../../../Components';
import { lookupItemsGetId } from '../../../../../../../../../../Services/LookupsServices';

export const CityComponent = ({
  parentTranslationPath,
  translationPath,
  cityId,
  setCityId,
  selected,
  setSelected,
  setDistrictList,
  cityList,
  addressLoadings ,
  setAddressLoadings ,
}) => {
  // const { t } = useTranslation([parentTranslationPath, 'Shared']);
      // eslint-disable-next-line no-unused-vars
  const [districts, setDistricts] = useState([]);

  useEffect(() => {
    setDistrictList(districts);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [districts]);

  const GetDistrict = useCallback(async (cityId) => {
    setAddressLoadings((item) => ({ ...item, district:true }));
    const res = await lookupItemsGetId({
      lookupTypeId: DistrictTypeIdEnum.lookupTypeId,
      lookupParentId: cityId,
    });

    if (!(res && res.status && res.status !== 200)) {
      setDistricts(res);
    } else
      setDistricts([]);

      setAddressLoadings((item) => ({ ...item, district:false }));
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (cityId && !selected.City && cityList.length > 0) {
      const cityIndex = cityList.findIndex((item) => item.lookupItemId === cityId);

      if (cityIndex !== -1) setSelected(cityList[cityIndex]);
      else setCityId(null);
    }
  }, [cityList, cityId, selected.City, setSelected, setCityId]);

  return (
    <div>
      <AutocompleteComponent
        idRef='cityRef'
        labelValue='city'
        multiple={false}
        selectedValues={selected.City}
        isLoading={addressLoadings.city}
        data={cityList && cityList ? cityList : []}
        displayLabel={(option) => option.lookupItemName || ''}
        getOptionSelected={(option) => option.lookupItemId === selected.City.lookupItemId}
        withoutSearchButton
        onChange={(event, newValue) => {
          setSelected(newValue);
          setCityId(newValue &&  newValue.lookupItemId);
          if (newValue && newValue)
            GetDistrict(newValue.lookupItemId);
        }}
        parentTranslationPath={parentTranslationPath}
        translationPath={translationPath}
      />
    </div>
  );
};
